import React from 'react';
import { AppstoreOutlined } from '@ant-design/icons';
import { INTEGRATION_TYPE_ALIASES, INTEGRATION_TYPE_LOGOS } from '@/utils/integrations';

interface IntegrationLogoProps {
  type: string;
  size?: number;
  style?: React.CSSProperties;
}

const IntegrationLogo: React.FC<IntegrationLogoProps> = ({ type, size = 40, style }) => {
  const resolvedType = INTEGRATION_TYPE_ALIASES[type] || type;
  const logo = INTEGRATION_TYPE_LOGOS[resolvedType];

  if (logo) {
    return <img style={{ width: size, ...style }} src={logo} alt={type} />;
  }

  return <AppstoreOutlined style={{ fontSize: size, ...style }} />;
};

export default IntegrationLogo;
